<template>
  <div v-loading="loading" class="alarmClass">
    <div>
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="105px">
        <el-row :gutter="24">
          <el-col :span="8">
              <el-form-item label="设备IMEI号" prop="deviceSerial">
                
                <el-input
                  clearable
                  disabled
                   v-model="form.deviceSerial"
                  
                  maxlength="100"
                ></el-input> 
               
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="设备编号" prop="code">
                
                <el-input
                  clearable
                  disabled v-model="form.code"
                 
                  maxlength="100"
                ></el-input> 
               
              </el-form-item>
            </el-col>
  
            <el-col :span="8">
              <el-form-item label="设备名称" prop="name"> 
  
  
                <el-input
                  clearable
                  disabled
                   v-model="form.name"
                  
                  maxlength="20"
                ></el-input> 
                
              </el-form-item>
            </el-col>
          <el-col :span="24">
         <h4>保养信息</h4>
            <el-divider></el-divider>
          </el-col>
         
          <el-col :span="12">
            <el-form-item label="保养时间" prop="upkeepTime">
              <el-date-picker
                v-model="form.upkeepTime"
                style="width: 100%;"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="请选择保养时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="操作人员" prop="upkeepUserName">
              <el-input clearable placeholder="请输入操作人员"  v-model="form.upkeepUserName" maxlength="20"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="保养费用" prop="upkeepAmount">
                <money-input
                 v-model="form.upkeepAmount"
                templateName="元"
                template="append"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="保养说明" prop="description">
              <el-input
              maxlength="500"
                type="textarea"
                :rows="2"
                placeholder="请输入保养说明"
                v-model="form.description"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="text-align: right" v-if="model != 'view'">
      <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
        {{ model == 'add' ? '提交' : '修改' }}
      </el-button>
      <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small"> 取消 </el-button>
    </div>
  </div>
</template>
<script>
import { smartDeviceResumeUpkeepSave } from '@/api/nursingHome/elderDevice';

export default {
  components: {},
  props: {
    row: {
      default: {},
    },
  
    model: {
      default: 'add',
    },
  },
  data() {
    return {
      projectList: [],
      provideList: [],
      form: {
        deviceSerial:"",
        code: '',
        name: '',
        upkeepTime: '',
        upkeepUserName: '',
        troubleType: '',
        troubleReason: '',
        repairEndTime: '',
        upkeepAmount: '',
        description: '',
      },
      formRules: {
        upkeepTime: [{ required: true, message: '保养时间不能为空', trigger: 'change' }],
     
        upkeepUserName: [{ required: true, message: '操作人员不能为空', trigger: 'change' }],
      },
      matetialList: [],
      deviceCategoryList: [],
      userList: [],
      deviceTypeIdList: [],
      deviceModelIdList: [],
      
      paymentTypeList: [],
    };
  },
  created() {
    this.initData();
  },
  mounted() {},
  watch: {},
  methods: {
    
   initData() {
      this.form.deviceSerial = this.row.deviceSerial
      this.form.code = this.row.code
      this.form.name = this.row.name
      this.form.deviceId = this.row.id
    },
    saveRecord() {
      this.$refs['formRef'].validate((valid) => {
          if (valid) {
            smartDeviceResumeUpkeepSave(this.form).then((res) => {
              this.$message.success('新增成功');
              this.$emit('success');
            });
          }
        });
    },
    cancleRecord() {
      this.$emit('cancle');
    },
  },
};
</script>
<style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
::v-deep .el-col-8 {
  height: 54px;
}
</style>
